module.exports = __webpack_public_path__ + "static/media/menu.7d0ab5e5.svg";